import { render, staticRenderFns } from "./AssetDetailsInfo.vue?vue&type=template&id=6690889c&scoped=true&"
import script from "./AssetDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./AssetDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailsInfo.vue?vue&type=style&index=0&id=6690889c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690889c",
  null
  
)

export default component.exports